import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e4bb616"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-input" }
const _hoisted_2 = ["id", "value", "disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-input__seprator" }, "/", -1))
const _hoisted_4 = ["id", "value", "disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-input__seprator" }, "/", -1))
const _hoisted_6 = ["id", "value", "disabled"]
const _hoisted_7 = {
  key: 0,
  class: "form-input__hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'form-input__inner',
        _ctx.active && 'form-input__inner--active',
        _ctx.disabled && 'form-input__inner--disabled',
        _ctx.error && 'form-input__inner--error',
      ])
    }, [
      _createElementVNode("label", {
        class: _normalizeClass([
          'form-input__label',
          (_ctx.active || _ctx.modelValue) && 'form-input__label--active',
          _ctx.disabled && 'form-input__label--disabled',
          _ctx.error && 'form-input__label--error',
        ]),
        style: _normalizeStyle([
          !_ctx.disabled && { backgroundColor: _ctx.bgColor },
          !_ctx.bgColor && { backgroundColor: '#fff' },
          _ctx.modelValue && _ctx.modelValue.length && !_ctx.active && { color: _ctx.color },
        ])
      }, _toDisplayString(_ctx.label), 7),
      _createElementVNode("div", {
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
        onFocusout: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onFocusout && _ctx.onFocusout(...args))),
        class: "form-input__wrapper",
        style: _normalizeStyle([!_ctx.active && !_ctx.modelValue && 'opacity: 0'])
      }, [
        _createElementVNode("input", {
          class: "form-input__html",
          ref: "dayInputRef",
          id: _ctx.id + '0',
          value: _ctx.day,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput($event, 'day'))),
          onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFocus('day'))),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.onDelete($event, 'day')), ["delete"])),
          inputmode: "numeric",
          integral: "",
          number: "",
          disabled: _ctx.disabled,
          egative: "",
          minlength: "2",
          maxlength: "2",
          placeholder: "__"
        }, null, 40, _hoisted_2),
        _hoisted_3,
        _createElementVNode("input", {
          class: "form-input__html",
          ref: "monthInputRef",
          id: _ctx.id + '1',
          value: _ctx.month,
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onInput($event, 'month'))),
          onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
          onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFocus('month'))),
          onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.onDelete($event, 'month')), ["delete"])),
          inputmode: "numeric",
          integral: "",
          number: "",
          disabled: _ctx.disabled,
          egative: "",
          minlength: "2",
          maxlength: "2",
          placeholder: "__"
        }, null, 40, _hoisted_4),
        _hoisted_5,
        _createElementVNode("input", {
          class: "form-input__html",
          ref: "yearInputRef",
          id: _ctx.id + '2',
          value: _ctx.year,
          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onInput($event, 'year'))),
          onKeydown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
          onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onFocus('year'))),
          onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.onDelete($event, 'year')), ["delete"])),
          inputmode: "numeric",
          integral: "",
          number: "",
          disabled: _ctx.disabled,
          egative: "",
          maxlength: "4",
          minlength: "4",
          placeholder: "____"
        }, null, 40, _hoisted_6)
      ], 36),
      (_ctx.appendLabel)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([
          'form-input__append-label',
          _ctx.readonly && 'form-input__append-label--readonly',
        ])
          }, _toDisplayString(_ctx.appendLabel), 3))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut",
      class: "animate__faster",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.hint && !_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.hint), 1))
          : (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(['form-input__hint', _ctx.error && 'form-input__hint--error'])
              }, _toDisplayString(_ctx.errorMessage), 3))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}